import type * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import * as records from '../../records'
import type { TypeParams } from '../types'

/**
 * After a new employee is created during a bulk responsible persons update,
 * adds them to the employees being made responsible, so they appear checked
 * without any further user interaction.
 */
export const autoSelectOnCreateForBulkResponsiblePersons = store.effects.create(
  (
    _: ec.Collection<TypeParams>['feature'],
    collection: ec.Collection<TypeParams>,
    recordsEc: records.Collection,
  ) => {
    const bulkResponsiblePersonsPlugin = recordsEc.plugins
      .lookup(records.plugins.bulkResponsiblePersons.Plugin)
      .get()

    return collection.plugins.dataOperationPlugin.feature.actions.create.success
      .observe()
      .pipe(
        rxjs.withLatestFrom(
          bulkResponsiblePersonsPlugin.selectors.isUpdating.asObservable,
        ),
        rxjs.mergeMap(([action, isUpdating]) => {
          const employees = action.data.response ?? []

          if (!isUpdating || !employees.length) {
            return rxjs.EMPTY
          }

          return rxjs.of(
            bulkResponsiblePersonsPlugin.actions.toggleEmployees
              .from('autoSelectOnCreateForBulkResponsiblePersons (effect)')
              .create({
                employeeIds: employees.map(employee => employee.id),
                selected: true,
              }),
          )
        }),
      )
  },
)
